import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { DatePicker, Row, Col, Form, Select, AutoComplete, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import useDispatchHttp from '../../../hooks/dispatchHttpHandler'
import { fetchAllUsers, selectAllUsersForSelect } from '../../../state/modules/users'
import { DATE_FORMAT } from '../../../constants'
import { useUser } from '../../../providers/UserProvider'

const defaultActorOptions = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Jaia User',
    value: 'gaia_user',
  },
  {
    label: 'System',
    value: 'parameds_cms',
  },
]

const defaultActorOptionsUsersNotAllowed = [
  {
    label: 'System',
    value: 'parameds_cms',
  },
]

const ActivityLogFiltersEntities = ({
  updateSearchParam,
  searchParams,
  handleTabSelect,
  tabs,
}) => {
  const dispatchHttp = useDispatchHttp()
  const [actorOptions, setActorOptions] = useState([...defaultActorOptions])
  const [actorDisplayValue, setActorDisplayValue] = useState('')
  const { id, firstname, lastname } = useSelector(state => state.auth)
  const users = useSelector(selectAllUsersForSelect)
  const { isUserActionAllowed } = useUser()
  const [form] = Form.useForm()

  useEffect(() => {
    let opts
    if (isUserActionAllowed('view_user')) {
      opts = [...defaultActorOptions, ...users]
    } else {
      opts = [
        ...defaultActorOptionsUsersNotAllowed,
        { value: id, label: `${firstname} ${lastname}` },
      ]
    }
    setActorOptions(opts)
    const currentValue = searchParams.user_id || searchParams.edited
    const matchedOption =
      currentValue !== 'all' ? opts.find(o => o.value === currentValue) : null
    setActorDisplayValue(matchedOption?.label || '')
    form.setFieldsValue({
      type: searchParams.entity,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users])

  useEffect(() => {
    if (isUserActionAllowed('view_user')) {
      dispatchHttp(fetchAllUsers({ skipPagination: true }))
    }
  }, [dispatchHttp, isUserActionAllowed])

  const handleSelect = value => {
    let param
    const isDefaultActorOption = defaultActorOptions.filter(
      variant => value === variant.value
    ).length

    if (isDefaultActorOption) {
      param = { edited: value }
    } else {
      param = { user_id: value }
    }

    updateSearchParam(param)
  }

  const handleFilterByDate = (dates, datesString) => {
    const date_range = datesString.filter(date => !!date).toString()

    updateSearchParam({ date_range })
  }

  const filteredActorOptions = actorDisplayValue
    ? actorOptions.filter(o =>
        o.label.toLowerCase().includes(actorDisplayValue.toLowerCase())
      )
    : actorOptions

  const handleActorSelect = (value, option) => {
    handleSelect(value)
    setActorDisplayValue(value === 'all' ? '' : option.label)
  }

  const handleActorInputChange = text => {
    setActorDisplayValue(text)
  }

  return (
    <Row className="activity-log-filter-form" justify="end" align="bottom">
      <Col>
        <Form form={form} layout="inline" className="sort-form" component="div">
          <Row gutter={[16, 32]}>
            <Col>
              <Form.Item label="Type" className="sort-form__select-field" name="type">
                <Select
                  size="middle"
                  className="sort-form__select"
                  onChange={handleTabSelect}
                  options={tabs}
                  placeholder="Select here"
                  value={searchParams.entity}
                />
              </Form.Item>
            </Col>
            <Col>
              <DatePicker.RangePicker
                format={DATE_FORMAT.year_month_day}
                onChange={handleFilterByDate}
              />
            </Col>
            <Col>
              <Form.Item label="Actor" className="sort-form__select-field">
                <AutoComplete
                  size="middle"
                  className="sort-form__select"
                  value={actorDisplayValue}
                  options={filteredActorOptions}
                  onSelect={handleActorSelect}
                  onChange={handleActorInputChange}
                  notFoundContent="No results found"
                >
                  <Input placeholder="Search..." suffix={<SearchOutlined />} />
                </AutoComplete>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  )
}

export default ActivityLogFiltersEntities
